import React from 'react';
import SEO from '../common/SEO';
import ColorSwitcher from '../elements/switcher/ColorSwitcher';
import { Link } from 'react-router-dom';
import { 
    FaApple, 
    FaGooglePlay, 
    FaWhatsapp, 
    FaEnvelope, 
    FaShieldAlt, 
    FaRocket, 
    FaStore, 
    FaLock,
    FaArrowRight,
    FaUserShield,
    FaHeadset
} from "react-icons/fa";

const ComingSoon = ({ brandName = "OOKEY", domain = "ookey.id" }) => {
    const isOkePos = domain.includes("okepos");

    return (
        <>
            <SEO title={`${brandName} - Layanan Segera Hadir`} />
            <ColorSwitcher />
            <main className="main-wrapper" style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', justifyContent: 'space-between', position: 'relative', overflowX: 'hidden' }}>
                
                {/* Top Header */}
                <header className="py-4" style={{ zIndex: 10 }}>
                    <div className="container d-flex justify-content-between align-items-center">
                        <div className="d-flex align-items-center gap-3">
                            <img 
                                src={process.env.PUBLIC_URL + "/images/ookey_logo_only.png"} 
                                alt={brandName} 
                                style={{ height: '42px', width: 'auto' }}
                                onError={(e) => { e.target.style.display = 'none'; }}
                            />
                            <span style={{ fontSize: '24px', fontWeight: 800, letterSpacing: '-0.5px', background: 'linear-gradient(135deg, #5956E9 0%, #FFDC60 100%)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>
                                {isOkePos ? "OkePOS" : "OOKEY"}
                            </span>
                        </div>
                        <div className="d-flex align-items-center gap-2 gap-sm-3">
                            <a 
                                href="https://pos.ookey.id" 
                                target="_blank" 
                                rel="noopener noreferrer"
                                className="axil-btn btn-outline coming-outline-btn d-inline-flex align-items-center"
                                style={{ padding: '8px 18px', fontSize: '13px', borderRadius: '30px' }}
                            >
                                <FaUserShield className="me-2 text-primary" /> Admin Cloud
                            </a>

                            <a 
                                href="https://pos.ookey.id/daftar-usaha" 
                                target="_blank" 
                                rel="noopener noreferrer"
                                className="axil-btn btn-fill-primary d-none d-sm-inline-flex"
                                style={{ padding: '9px 20px', fontSize: '13px', borderRadius: '30px' }}
                            >
                                <FaStore className="me-2" /> Daftar Usaha
                            </a>

                            <Link 
                                to="/admin-login" 
                                className="btn btn-outline-secondary btn-sm admin-lock-btn"
                                style={{ borderRadius: '50%', width: '36px', height: '36px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                                title="Admin Preview Login Website"
                            >
                                <FaLock size={13} />
                            </Link>
                        </div>
                    </div>
                </header>

                {/* Main Hero Section */}
                <div className="coming-soon-area onepage-screen-area py-5" style={{ flexGrow: 1, display: 'flex', alignItems: 'center' }}>
                    <div className="container">
                        <div className="row align-items-center justify-content-between g-5">
                            
                            {/* Left Column: Heading & Information */}
                            <div className="col-xl-7 col-lg-7">
                                <div className="content pe-lg-4">
                                    <div className="d-inline-flex align-items-center gap-2 px-3 py-1 mb-3 cs-badge">
                                        <FaRocket /> Website Baru Kami Sedang Dipersiapkan
                                    </div>
                                    
                                    <h1 className="title mb-3 cs-main-title" style={{ fontSize: 'calc(1.8rem + 1.5vw)', fontWeight: 800, lineHeight: 1.2 }}>
                                        {isOkePos 
                                            ? "Sistem Kasir & Operasional Terintegrasi untuk Bisnis Anda" 
                                            : "Platform Ekosistem Digital Pintar Terintegrasi"}
                                    </h1>
                                    
                                    <p className="description mb-4 cs-desc" style={{ fontSize: '16px', lineHeight: 1.6 }}>
                                        {isOkePos
                                            ? "Aplikasi kasir (POS) modern dengan sinkronisasi cloud real-time, manajemen inventaris, laporan keuangan akurat, serta dukungan Kitchen Display & Self-Order."
                                            : "Solusi terpadu mulai dari POS Resto & Retail, Smart Parking, EduOne, hingga Komuna. Download aplikasi kami sekarang untuk mulai mengelola bisnis Anda."}
                                    </p>

                                    {/* Primary CTA Buttons */}
                                    <div className="mb-5 d-flex flex-wrap gap-3 align-items-center">
                                        <a 
                                            href="https://pos.ookey.id/daftar-usaha" 
                                            target="_blank" 
                                            rel="noopener noreferrer"
                                            className="axil-btn btn-fill-primary"
                                            style={{ padding: '14px 28px', fontSize: '15px', borderRadius: '12px', boxShadow: '0 10px 30px rgba(89, 86, 233, 0.35)', fontWeight: 600 }}
                                        >
                                            <FaStore className="me-2" /> Daftar Usaha Sekarang <FaArrowRight className="ms-2" />
                                        </a>
                                        <a 
                                            href="https://pos.ookey.id" 
                                            target="_blank" 
                                            rel="noopener noreferrer"
                                            className="axil-btn btn-outline coming-outline-btn"
                                            style={{ padding: '14px 24px', fontSize: '15px', borderRadius: '12px', fontWeight: 600 }}
                                        >
                                            <FaUserShield className="me-2 text-primary" /> Login Admin Cloud
                                        </a>
                                        <a 
                                            href="https://wa.me/6283899669969" 
                                            target="_blank" 
                                            rel="noopener noreferrer"
                                            className="axil-btn btn-outline coming-outline-btn"
                                            style={{ padding: '14px 24px', fontSize: '15px', borderRadius: '12px', fontWeight: 600 }}
                                        >
                                            <FaWhatsapp className="me-2 text-success" /> Hubungi Kami
                                        </a>
                                    </div>

                                    {/* App Download Sections Card Grid */}
                                    <div className="download-box-wrapper pt-2">
                                        <h5 className="mb-3 cs-subtitle" style={{ fontSize: '14px', textTransform: 'uppercase', letterSpacing: '1px', fontWeight: 700 }}>
                                            Download Aplikasi Mobile Resmi
                                        </h5>
                                        
                                        <div className="row g-3">
                                            {/* OkePOS Resto Card */}
                                            <div className="col-md-6 col-12">
                                                <div className="p-3 cs-card shadow-sm" style={{ borderRadius: '16px', height: '100%' }}>
                                                    <div className="d-flex align-items-center gap-2 mb-2">
                                                        <span className="badge bg-primary px-2 py-1" style={{ fontSize: '11px', borderRadius: '6px' }}>Kasir & Waiter</span>
                                                        <span className="cs-card-title" style={{ fontWeight: 700, fontSize: '15px' }}>OkePOS Resto</span>
                                                    </div>
                                                    <p className="cs-card-desc" style={{ fontSize: '13px', marginBottom: '14px', lineHeight: 1.4 }}>Aplikasi kasir resto, F&B, open bill, KDS & print struk.</p>
                                                    <div className="d-flex gap-2">
                                                        <a 
                                                            href="https://apps.apple.com/app/okepos-resto-by-ookey/id6799837982" 
                                                            target="_blank" 
                                                            rel="noopener noreferrer"
                                                            className="btn cs-btn-app btn-sm flex-fill d-flex align-items-center justify-content-center gap-2 py-2"
                                                            style={{ borderRadius: '8px', fontSize: '12px', fontWeight: 600 }}
                                                        >
                                                            <FaApple size={16} /> iOS
                                                        </a>
                                                        <a 
                                                            href="https://play.google.com/store/apps/details?id=id.ookey.pos.resto" 
                                                            target="_blank" 
                                                            rel="noopener noreferrer"
                                                            className="btn cs-btn-app btn-sm flex-fill d-flex align-items-center justify-content-center gap-2 py-2"
                                                            style={{ borderRadius: '8px', fontSize: '12px', fontWeight: 600 }}
                                                        >
                                                            <FaGooglePlay size={13} className="text-success" /> Android
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>

                                            {/* OkePOS Owner Card */}
                                            <div className="col-md-6 col-12">
                                                <div className="p-3 cs-card shadow-sm" style={{ borderRadius: '16px', height: '100%' }}>
                                                    <div className="d-flex align-items-center gap-2 mb-2">
                                                        <span className="badge bg-warning text-dark px-2 py-1" style={{ fontSize: '11px', borderRadius: '6px' }}>Owner & Manager</span>
                                                        <span className="cs-card-title" style={{ fontWeight: 700, fontSize: '15px' }}>OkePOS Owner</span>
                                                    </div>
                                                    <p className="cs-card-desc" style={{ fontSize: '13px', marginBottom: '14px', lineHeight: 1.4 }}>Monitoring omzet, laporan cabang, profit & inventory.</p>
                                                    <div className="d-flex gap-2">
                                                        <a 
                                                            href="https://apps.apple.com/app/okepos-owner-by-ookey/id6806181529" 
                                                            target="_blank" 
                                                            rel="noopener noreferrer"
                                                            className="btn cs-btn-app btn-sm flex-fill d-flex align-items-center justify-content-center gap-2 py-2"
                                                            style={{ borderRadius: '8px', fontSize: '12px', fontWeight: 600 }}
                                                        >
                                                            <FaApple size={16} /> iOS
                                                        </a>
                                                        <a 
                                                            href="https://play.google.com/store/apps/details?id=id.ookey.pos.owner" 
                                                            target="_blank" 
                                                            rel="noopener noreferrer"
                                                            className="btn cs-btn-app btn-sm flex-fill d-flex align-items-center justify-content-center gap-2 py-2"
                                                            style={{ borderRadius: '8px', fontSize: '12px', fontWeight: 600 }}
                                                        >
                                                            <FaGooglePlay size={13} className="text-success" /> Android
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Right Column: Clean Help & Contact Box Widget */}
                            <div className="col-xl-5 col-lg-5">
                                <div className="p-4 p-md-5 cs-contact-box" style={{ borderRadius: '24px' }}>
                                    <div className="text-center mb-4">
                                        <div style={{ width: '56px', height: '56px', borderRadius: '50%', background: 'linear-gradient(135deg, #5956E9 0%, #FFDC60 100%)', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', marginBottom: '14px', color: '#ffffff', fontSize: '22px' }}>
                                            <FaHeadset />
                                        </div>
                                        <h3 className="title mb-2 cs-contact-title" style={{ fontWeight: 700, fontSize: '24px' }}>Pusat Bantuan & Layanan</h3>
                                        <p className="cs-desc" style={{ fontSize: '14px', marginBottom: 0 }}>Hubungi tim kami jika ada pertanyaan atau butuh demo langsung.</p>
                                    </div>

                                    <div className="d-flex flex-column gap-3">
                                        {/* WhatsApp Support Card */}
                                        <a 
                                            href="https://wa.me/6283899669969" 
                                            target="_blank" 
                                            rel="noopener noreferrer"
                                            className="d-flex align-items-center gap-3 p-3 text-decoration-none cs-item-link"
                                            style={{ borderRadius: '14px' }}
                                        >
                                            <div style={{ width: '44px', height: '44px', borderRadius: '12px', background: '#25D366', color: '#ffffff', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '22px', flexShrink: 0 }}>
                                                <FaWhatsapp />
                                            </div>
                                            <div>
                                                <div className="cs-item-label" style={{ fontSize: '12px', fontWeight: 500 }}>WhatsApp Support</div>
                                                <div className="cs-item-val" style={{ fontWeight: 700, fontSize: '16px' }}>+62 838-9966-9969</div>
                                            </div>
                                        </a>

                                        {/* Email Card */}
                                        <a 
                                            href={isOkePos ? "mailto:pos@ookey.id" : "mailto:support@ookey.id"} 
                                            className="d-flex align-items-center gap-3 p-3 text-decoration-none cs-item-link"
                                            style={{ borderRadius: '14px' }}
                                        >
                                            <div style={{ width: '44px', height: '44px', borderRadius: '12px', background: '#5956E9', color: '#ffffff', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '20px', flexShrink: 0 }}>
                                                <FaEnvelope />
                                            </div>
                                            <div>
                                                <div className="cs-item-label" style={{ fontSize: '12px', fontWeight: 500 }}>Email Resmi</div>
                                                <div className="cs-item-val" style={{ fontWeight: 700, fontSize: '16px' }}>{isOkePos ? "pos@ookey.id" : "support@ookey.id"}</div>
                                            </div>
                                        </a>

                                        {/* POS Cloud Portal Card */}
                                        <a 
                                            href="https://pos.ookey.id" 
                                            target="_blank" 
                                            rel="noopener noreferrer"
                                            className="d-flex align-items-center gap-3 p-3 text-decoration-none cs-item-link-portal"
                                            style={{ borderRadius: '14px' }}
                                        >
                                            <div style={{ width: '44px', height: '44px', borderRadius: '12px', background: '#5956E9', color: '#ffffff', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '20px', flexShrink: 0 }}>
                                                <FaUserShield />
                                            </div>
                                            <div>
                                                <div className="cs-item-label-portal" style={{ fontSize: '12px', fontWeight: 500 }}>Portal POS Cloud</div>
                                                <div className="cs-item-val" style={{ fontWeight: 700, fontSize: '16px' }}>pos.ookey.id (Login Admin)</div>
                                            </div>
                                        </a>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>

                    {/* Animated Theme Shapes */}
                    <ul className="shape-group-8 list-unstyled">
                        <li className="shape shape-2">
                            <img src={process.env.PUBLIC_URL + "/images/others/bubble-28.png"} alt="Bubble" />
                        </li>
                        <li className="shape shape-3">
                            <img src={process.env.PUBLIC_URL + "/images/others/line-4.png"} alt="Line" />
                        </li>
                    </ul>
                </div>

                {/* Simple Footer */}
                <footer className="py-4 border-top cs-footer" style={{ zIndex: 10 }}>
                    <div className="container d-flex flex-column flex-sm-row justify-content-between align-items-center gap-3">
                        <div className="cs-footer-text" style={{ fontSize: '13px' }}>
                            © {new Date().getFullYear()} PT Smart Integrasi Pratama ({brandName}). All Rights Reserved.
                        </div>
                        <div className="d-flex align-items-center gap-4">
                            <a 
                                href="https://pos.ookey.id" 
                                target="_blank" 
                                rel="noopener noreferrer"
                                className="cs-footer-link"
                                style={{ fontSize: '13px', textDecoration: 'none' }}
                            >
                                <FaUserShield className="me-1 text-primary" /> Admin POS Cloud
                            </a>
                            <Link 
                                to="/privacy-policy" 
                                className="cs-footer-link hover-primary"
                                style={{ fontSize: '13px', textDecoration: 'none' }}
                            >
                                <FaShieldAlt className="me-1" /> Kebijakan Privasi
                            </Link>
                        </div>
                    </div>
                </footer>

                {/* Theme Responsive Dual Color CSS */}
                <style>{`
                    /* ================= DARK THEME (DEFAULT / active-dark-mode) ================= */
                    .active-dark-mode .cs-main-title { color: #ffffff !important; }
                    .active-dark-mode .cs-desc { color: #9da3b8 !important; }
                    .active-dark-mode .cs-subtitle { color: #8e94b2 !important; }
                    .active-dark-mode .cs-badge { background: rgba(89, 86, 233, 0.15); border: 1px solid rgba(89, 86, 233, 0.4); color: #8b89ff; }
                    .active-dark-mode .cs-card { background: #1c1e2f; border: 1px solid #2d304a; }
                    .active-dark-mode .cs-card-title { color: #ffffff !important; }
                    .active-dark-mode .cs-card-desc { color: #9da3b8 !important; }
                    .active-dark-mode .cs-btn-app { background: #262940; border: 1px solid #3d4266; color: #ffffff !important; }
                    .active-dark-mode .cs-btn-app:hover { background: #5956E9; border-color: #5956E9; color: #ffffff !important; }
                    .active-dark-mode .coming-outline-btn { border: 1px solid rgba(255,255,255,0.25) !important; color: #ffffff !important; }
                    .active-dark-mode .coming-outline-btn:hover { background: #5956E9; border-color: #5956E9; color: #ffffff !important; }
                    .active-dark-mode .admin-lock-btn { border-color: rgba(255,255,255,0.2); color: #bbb; }
                    .active-dark-mode .cs-contact-box { background: #171927; border: 1px solid #282a3e; box-shadow: 0 20px 50px rgba(0,0,0,0.4); }
                    .active-dark-mode .cs-contact-title { color: #ffffff !important; }
                    .active-dark-mode .cs-item-link { background: #212338; border: 1px solid #313554; }
                    .active-dark-mode .cs-item-label { color: #9da3b8; }
                    .active-dark-mode .cs-item-val { color: #ffffff !important; }
                    .active-dark-mode .cs-item-link-portal { background: linear-gradient(135deg, rgba(89,86,233,0.2) 0%, rgba(33,35,56,1) 100%); border: 1px solid #5956E9; }
                    .active-dark-mode .cs-item-label-portal { color: #c4c8dd; }
                    .active-dark-mode .cs-footer { border-color: rgba(255,255,255,0.08) !important; }
                    .active-dark-mode .cs-footer-text { color: #888; }
                    .active-dark-mode .cs-footer-link { color: #a0a5b8; }

                    /* ================= LIGHT THEME (active-light-mode / default light) ================= */
                    .active-light-mode .cs-main-title, body:not(.active-dark-mode) .cs-main-title { color: #27272e !important; }
                    .active-light-mode .cs-desc, body:not(.active-dark-mode) .cs-desc { color: #525260 !important; }
                    .active-light-mode .cs-subtitle, body:not(.active-dark-mode) .cs-subtitle { color: #525260 !important; }
                    .active-light-mode .cs-badge, body:not(.active-dark-mode) .cs-badge { background: rgba(89, 86, 233, 0.08); border: 1px solid rgba(89, 86, 233, 0.2); color: #5956E9; }
                    .active-light-mode .cs-card, body:not(.active-dark-mode) .cs-card { background: #ffffff; border: 1px solid #e3e6ef; box-shadow: 0 10px 30px rgba(0,0,0,0.05); }
                    .active-light-mode .cs-card-title, body:not(.active-dark-mode) .cs-card-title { color: #27272e !important; }
                    .active-light-mode .cs-card-desc, body:not(.active-dark-mode) .cs-card-desc { color: #71717a !important; }
                    .active-light-mode .cs-btn-app, body:not(.active-dark-mode) .cs-btn-app { background: #f4f5f8; border: 1px solid #dcdfe8; color: #27272e !important; }
                    .active-light-mode .cs-btn-app:hover, body:not(.active-dark-mode) .cs-btn-app:hover { background: #5956E9; border-color: #5956E9; color: #ffffff !important; }
                    .active-light-mode .coming-outline-btn, body:not(.active-dark-mode) .coming-outline-btn { border: 1.5px solid #5956E9 !important; color: #5956E9 !important; background: transparent; }
                    .active-light-mode .coming-outline-btn:hover, body:not(.active-dark-mode) .coming-outline-btn:hover { background: #5956E9 !important; color: #ffffff !important; }
                    .active-light-mode .admin-lock-btn, body:not(.active-dark-mode) .admin-lock-btn { border-color: #dcdfe8; color: #525260; }
                    .active-light-mode .cs-contact-box, body:not(.active-dark-mode) .cs-contact-box { background: #ffffff; border: 1px solid #e3e6ef; box-shadow: 0 15px 40px rgba(0,0,0,0.06); }
                    .active-light-mode .cs-contact-title, body:not(.active-dark-mode) .cs-contact-title { color: #27272e !important; }
                    .active-light-mode .cs-item-link, body:not(.active-dark-mode) .cs-item-link { background: #f8f9fc; border: 1px solid #e3e6ef; }
                    .active-light-mode .cs-item-label, body:not(.active-dark-mode) .cs-item-label { color: #71717a; }
                    .active-light-mode .cs-item-val, body:not(.active-dark-mode) .cs-item-val { color: #27272e !important; }
                    .active-light-mode .cs-item-link-portal, body:not(.active-dark-mode) .cs-item-link-portal { background: linear-gradient(135deg, rgba(89,86,233,0.08) 0%, rgba(248,249,252,1) 100%); border: 1px solid #5956E9; }
                    .active-light-mode .cs-item-label-portal, body:not(.active-dark-mode) .cs-item-label-portal { color: #5956E9; }
                    .active-light-mode .cs-footer, body:not(.active-dark-mode) .cs-footer { border-color: #e5e7eb !important; }
                    .active-light-mode .cs-footer-text, body:not(.active-dark-mode) .cs-footer-text { color: #71717a; }
                    .active-light-mode .cs-footer-link, body:not(.active-dark-mode) .cs-footer-link { color: #525260; }
                `}</style>

            </main>
        </>
    );
};

export default ComingSoon;
